import { Transition } from "../../../core/flows/Transition";
import { ChangeDateContext } from "../Context/ChangeDateContext";
import { SelectOfferContext } from "../../TrainOfferPage/SelectOfferFlow/Context/SelectOfferContext";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";

export class ChangeDateTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {        
        const context = this.getCtx<ChangeDateContext>("changeDateContext", this.entryStep)!;

        const selectOfferContext = new SelectOfferContext()
        this.setCtx<SelectOfferContext>("SelectOfferContext", selectOfferContext, this.entryStep)

        const ticketOptionContext = new TicketOptionContext()
        this.setCtx<TicketOptionContext>("ticketOptionContext", ticketOptionContext, this.entryStep);
        context.routeTo = ["SelectOfferFlow", "TicketOptionFlow"]

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }
        return [...(context?.routeTo ?? [])]
    }

}